export default {
  red: '#E10600',
  white: '#fff',
  blue: '#002855',
  lightBlue: '#1680E4',
};
